import SlashRouteAction from '../actions/slashRouteAction';

function SlashRouteReducer(state = {
    onSlashRoute: false,
}, action) {

    switch (action.type) {
        case SlashRouteAction.ON_SLASH_ROUTE:
            return {
                onSlashRoute: action.data,
        }
        default:
            return state;
    }
}

export default SlashRouteReducer;


// WEBPACK FOOTER //
// ./src/store/reducer/slashRouteReducer.js